var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackNextEn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6 21.2C16.9019 21.2 21.2 16.9019 21.2 11.6C21.2 6.29807 16.9019 2 11.6 2C6.29807 2 2 6.29807 2 11.6C2 16.9019 6.29807 21.2 11.6 21.2ZM16.0485 10.7515L12.4485 7.15147C11.9799 6.68284 11.2201 6.68284 10.7515 7.15147C10.2828 7.6201 10.2828 8.3799 10.7515 8.84853L12.3029 10.4L8 10.4C7.33726 10.4 6.8 10.9373 6.8 11.6C6.8 12.2627 7.33726 12.8 8 12.8H12.3029L10.7515 14.3515C10.2828 14.8201 10.2828 15.5799 10.7515 16.0485C11.2201 16.5172 11.9799 16.5172 12.4485 16.0485L16.0485 12.4485C16.5172 11.9799 16.5172 11.2201 16.0485 10.7515Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackNextEn);
export default __webpack_public_path__ + "static/media/black-next-en.d3a09021c59b76ff6e33beb27d07a8fc.svg";
export { ForwardRef as ReactComponent };